import { useState, useEffect } from "react";
import { mapStatusWithdrawal } from "../utils/functions";
import axios from "../customAxios.js";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableCell,
  TableRow,
} from "@mui/material";

function WithdrawalRow(props) {
  const { withdrawal, columns, color, fetchWithdrawals } = props;
  const withdrawalStates = ["pending", "withdrawn"];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpdateState = async (state) => {
    if (state === withdrawal.status) {
      console.log("El estado es el mismo");
      setSelectedStatus("");
      return;
    }
    setSelectedStatus("");
    setLoading(true);
    try {
      await axios.put("withdrawals/update_withdrawal_status/", {
        id: withdrawal.id,
        status: state,
      });
      fetchWithdrawals();
      console.info("Se ha actualizado correctamente el estado del retiro");
    } catch (error) {
      console.error(`Error al actualizar el estado del retiro: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          if (column.enabled) {
            if (column.columnName === "Acciones") {
              return (
                <TableCell key={`action-${index}`} className="actions-cell">
                  <div className="actions-container">
                    <FormControl
                      fullWidth
                      variant="outlined"
                      className="dropdown-update-status"
                    >
                      <InputLabel id="dropdown-update-status-label">
                        Actualiza el estado
                      </InputLabel>
                      <Select
                        label="Actualiza el estado"
                        labelId="dropdown-update-status-label"
                        value={selectedStatus}
                        onChange={(e) => {
                          setSelectedStatus(e.target.value);
                          handleUpdateState(e.target.value);
                        }}
                        IconComponent={() => (
                          <i className="material-icons-outlined">expand_more</i>
                        )}
                      >
                        {withdrawalStates.map((state, index) => (
                          <MenuItem
                            className="dropdown-update-status-item"
                            key={index}
                            value={state}
                          >
                            {mapStatusWithdrawal(state)}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </TableCell>
              );
            } else {
              return (
                <TableCell
                  component="th"
                  scope="row"
                  key={`${column.columnName}-${index}`}
                >
                  {column.dbName === "id"
                    ? withdrawal[column.dbName]
                    : column.dbName === "warehouse_name"
                    ? withdrawal.warehouse.name
                    : column.dbName === "courier_name"
                    ? "EL COURIER ASOCIADO AL RETIRO - HARDCODEADO"
                    : column.dbName === "status"
                    ? mapStatusWithdrawal(withdrawal[column.dbName])
                    : "COLUMNA DESCONOCIDA"}
                </TableCell>
              );
            }
          }
        })}
      </TableRow>
    </>
  );
}

export default WithdrawalRow;
